<template>
  <div
    class="create_ai_mask"
    @click="mask($event)"
    data-mask="mask"
    v-if="show"
  >
    <div class="ads_contain" style="height: 625px; width: 630px">
      <div class="close_ads" @click="close">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <iframe
        height="100%"
        width="100%"
        v-show="!isAds"
        src="https://sharkfoto.com/ads/pop/index.html"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
      ></iframe>
      <div class="goole">
        <ClientOnly>
          <div class="adswrapper" ref="adsWrapper">
            <Adsense
              class="adsbygoogle"
              adStyle="display:block"
              format="fluid"
              clientId="ca-pub-6439841372484008"
              slotId="2809283864"
              fullWidthResponsive="true"
            />
          </div>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      dom: null, // 指向 .adsbygoogle 的 DOM
      interval: null,
      isAds: false,
      observer: null,
    };
  },
  mounted() {
    // 等待下一帧，确保 ClientOnly 已渲染
    this.$nextTick(() => {
      const wrapper = this.$refs.adsWrapper; // 这是 DOM 元素
      if (!wrapper) return;
      // 找到真正的谷歌广告节点
      this.dom = wrapper.querySelector(".adsbygoogle");

      // 若没找到，退而求其次用轮询（部分库会动态插入）
      if (!this.dom) {
        this.interval = setInterval(() => {
          const el = wrapper.querySelector(".adsbygoogle");
          if (el) {
            this.dom = el;
            clearInterval(this.interval);
            this.watchAdStatus();
          }
        }, 500);
      } else {
        this.watchAdStatus();
      }
    });
  },
  beforeUnmount() {
    // Vue 3
    if (this.interval) clearInterval(this.interval);
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    watchAdStatus() {
      if (!this.dom) return;

      // 初始判定一次
      this.applyAdStatus(this.dom.dataset.adStatus);

      // 用 MutationObserver 监听 data-ad-status 变化（更可靠，少轮询）
      this.observer = new MutationObserver(() => {
        this.applyAdStatus(this.dom.dataset.adStatus);
      });
      this.observer.observe(this.dom, {
        attributes: true,
        attributeFilter: ["data-ad-status"],
      });
    },
    applyAdStatus(status) {
      // 这里是“正确”的含义：
      // filled    = 广告位填充成功 -> 显示谷歌广告，隐藏你的 iframe 兜底
      // unfilled  = 未填充        -> 隐藏谷歌广告，显示你的 iframe 兜底
      if (status === "filled") {
        this.isAds = true;
        this.dom.style.paddingTop = "25px";
        const wrapperEl = this.$refs.adsWrapper;
        if (wrapperEl) {
          wrapperEl.style.height = "100%";
          wrapperEl.style.overflow = "visible";
        }
      } else if (status === "unfilled") {
        this.isAds = false;
        if (this.dom) this.dom.style.display = "none";
      }
    },
    mask(e) {
      if (e.target.dataset.mask === "mask") this.close();
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 950px) {
  .ads_contain {
    width: 500px !important;
    height: 600px !important;
  }
}
@media only screen and (max-width: 650px) {
  .ads_contain {
    width: 300px !important;
    height: 400px !important;
    padding: 14px 15px 12px 15px !important;
  }
}
.create_ai_mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .ads_contain {
    padding: 14px 30px 12px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 600px;
    min-height: 400px;
    position: relative;
    .close_ads {
      position: absolute;
      width: 32px;
      height: 32px;
      top: 20px;
      right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 50%;
      transition: all 0.2s ease;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        color: #333333;
        transform: scale(1.1);
      }
      &:active {
        transform: scale(0.95);
      }
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.goole {
  width: 100%;
}
.adsbygoogle {
  padding: 8px;
  // max-height: 800px !important;
  // height: 100%;
  height: 0px;
  overflow: hidden;
  min-width: 250px !important;
  max-width: 570px;
  width: 100% !important;
  box-sizing: border-box;
  > div,
  iframe {
    height: 100% !important;
    max-height: 800px !important;
    width: 100% !important;
  }
  &[data-ad-status="unfilled"] {
    display: none !important;
  }
}
.adswrapper {
  box-sizing: border-box;
  width: 100%;
  :deep(.adsbygoogle) {
    margin-top: 30px;
    padding: 0;
    max-height: 150px !important;
    height: 150px;
    width: 100% !important;
    box-sizing: border-box;
    > div,
    iframe {
      max-height: 150px !important;
      width: 100% !important;
    }
    &[data-ad-status="unfilled"] {
      display: none !important;
      margin: 0 !important;
    }
  }
}
</style>
